// extracted by mini-css-extract-plugin
export default {"successpage":"success_successpage__-XZAy","bottombtn":"success_bottombtn__be1fp"};